export const getGmtOffsetLabel = (ianaTimezone: string, date = new Date()) => {
  try {
    const dtf = new Intl.DateTimeFormat('en-US', {
      timeZone: ianaTimezone,
      timeZoneName: 'shortOffset',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    })

    const tzName = dtf.formatToParts(date).find((p) => p.type === 'timeZoneName')?.value
    if (!tzName) {
      return '(GMT+00:00)'
    }

    const match = tzName.match(/^GMT([+-])(\d{1,2})(?::(\d{2}))?$/)
    if (!match) {
      return '(GMT+00:00)'
    }

    const sign = match[1]
    const hh = String(Number(match[2])).padStart(2, '0')
    const mm = String(Number(match[3] ?? '0')).padStart(2, '0')
    return `(GMT${sign}${hh}:${mm})`
  } catch {
    return '(GMT+00:00)'
  }
}
